export default __webpack_public_path__ + "static/media/54542ABC-F302-49FF-828F-9EAE84F25CEE_1_105_c.3ff2f77d.jpeg";